import _ from 'lodash';
import { AnyAction } from 'redux';
import { updateInfoBadgeCountOfSideBarHeader } from 'src/adminPanel/components/sideBar/sideBarMenuItems';
import { ROUTE_ADMIN_OFFICE_CONFIRMATION } from 'src/config/routes';
import { singleEntityDefaultState, SingleEntityState } from '../entities/types/SingleEntityState';
import { FAILURE_CONFIRMATIONS, REQUEST_CONFIRMATIONS, SUCCESS_CONFIRMATIONS } from './actions';

export function confirmationsReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_CONFIRMATIONS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CONFIRMATIONS:
            ROUTE_ADMIN_OFFICE_CONFIRMATION.infoBadgeCount = action.response.data.length;
            updateInfoBadgeCountOfSideBarHeader();
            return _.assign({}, state, { isFetching: false, items: action.response.data, error: undefined });
        case FAILURE_CONFIRMATIONS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}
